import { CaseReducer, createSlice } from '@reduxjs/toolkit';

import { anonCustomer, CustomerState } from 'models/Customer';

import { deleteSession, getCustomer } from './customer.thunk';

export const initialState: CustomerState = {
  loading: false,
  data: null,
  error: null,
};

const handleLoading: CaseReducer = (state) => {
  state.loading = true;
  state.data = null;
  state.error = null;
};

const handleFulfilled: CaseReducer = (state, action) => {
  state.loading = false;
  state.data = action.payload;
  state.error = null;
};

const handleError: CaseReducer = (state, action) => {
  state.loading = false;
  state.data = anonCustomer;
  state.error = action.payload || action.error;
};

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getCustomer
    builder.addCase(getCustomer.pending, handleLoading);
    builder.addCase(getCustomer.fulfilled, handleFulfilled);
    builder.addCase(getCustomer.rejected, handleError);

    // deleteSession
    builder.addCase(deleteSession.pending, handleLoading);
    builder.addCase(deleteSession.fulfilled, handleFulfilled);
    builder.addCase(deleteSession.rejected, handleError);
  },
});

export { deleteSession, getCustomer };
